// mixin.js
import { deepClone, queryString } from '@/utils'
import Cookies from 'js-cookie'
import { getToken } from '@/utils/auth' // get token from cookie
const mixin = {
  methods: {
    // path: 跳转的路径
    // title: 导航上的名字
    // params: 需要带的参数
    goto(path, title, params = {}) {
      const pathArr = path.split('/')
      const routeData = this.$store.state.permission.routes.find(r => {
        const path = r.path.split('/')
        return path[path.length - 1] === pathArr[pathArr.length - 2] && path[path.length - 2] === pathArr[pathArr.length - 3]
      })
      let routeChildren = {}
      if (routeData) {
        routeChildren = routeData.children.find(r => r.path === pathArr[pathArr.length - 1])
      } else {
        return false
      }
      const newRoute = deepClone(routeData)
      const newRouteChildren = deepClone(routeChildren)
      const v = new Date().getTime()
      newRouteChildren.meta.title = title
      newRouteChildren.name = newRouteChildren.name + v
      newRouteChildren.path = newRouteChildren.path + v
      newRoute.children = [newRouteChildren]
      this.$router.addRoutes([newRoute])
      localStorage.setItem('orderRouter', JSON.stringify({
        fullPath: newRoute.path,
        name: newRouteChildren.name,
        path: newRouteChildren.path,
        title: newRouteChildren.meta.title,
        token: getToken()
      }))
      this.$router.push({ name: newRouteChildren.name, query: params })
    },

    export(api, params, title, router) {
      params = Object.assign({
        'x-token': this.$store.getters.token,
        router: router || window.location.hash.slice(1)
      }, params)
      const download_window = window.open(process.env.VUE_APP_BASE_API + api + '?' + queryString(params))
      download_window.document.title = title || '正在导出，请稍等'
    },

    exportTask(api, title, localhost) {
      const download_window = window.open(localhost + process.env.VUE_APP_BASE_API + '/' + api)
      download_window.document.title = title || '正在导出，请稍等'
    },

    exportIframe(api, params, router) {
      return new Promise(resolve => {
        const cookieKey = this.$store.getters.uid + '-' + new Date().getTime()
        const param = Object.assign({
          'x-token': this.$store.getters.token,
          router: router || window.location.hash.slice(1),
          uuid: cookieKey
        }, params)
        let url = process.env.VUE_APP_BASE_API + api
        let index = 0
        for (const key in param) {
          url += `${index === 0 ? '?' : '&'}${key}=${param[key]}`
          index += 1
        }
        var downloadFileUrl = url
        var elemIF = document.createElement('iframe')
        elemIF.src = downloadFileUrl
        elemIF.style.display = 'none'
        document.body.appendChild(elemIF)
        elemIF.onload = () => {
          let data = ''
          let param = { code: 0, message: '成功' }
          let messageDom = elemIF.contentDocument
          if (elemIF.contentDocument) {
            messageDom = messageDom.getElementsByTagName('pre')
            if (messageDom.length > 0) {
              data = messageDom[0].innerHTML
            }
          }

          if (data && data.indexOf('}') === data.length - 1 && data.indexOf('{') === 0) {
            param = JSON.parse(data)
          }
          const body = document.body
          body.removeChild(elemIF)
          resolve(param)
        }

        // 成功返回
        const sI = setInterval(() => {
          if (Cookies.get(cookieKey)) {
            Cookies.remove(cookieKey)
            clearInterval(sI)
            resolve()
          }
        }, 2000)
      })
    },

    wrapUploadLink(link, params) {
      const router = window.location.hash.slice(1).split('?')[0]
      params = Object.assign({
        router
      }, params)
      return process.env.VUE_APP_BASE_API + link + '?' + queryString(params)
    },

    copyLink(link, message = '复制成功') {
      const el = document.createElement('textarea')
      el.value = link
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.$message.success(message)
    },

    openNewWindowPost(url, param, router) {
      const form = document.createElement('form')
      form.action = process.env.VUE_APP_BASE_API + url + `?x-token=${this.$store.getters.token}&router=${router || window.location.hash.slice(1)}`
      form.target = '_blank'
      form.method = 'post'
      form.style.display = 'none'
      console.log(param)

      for (var x in param) {
        if (param[x].constructor === Array) {
          param[x].forEach((element, index) => {
            // 数组json [{key: val}]
            if (element.constructor === Object) {
              for (const key in element) {
                const opt = document.createElement('textarea')
                opt.name = `${x}[${index}][${key}]`
                opt.value = element[key]
                form.appendChild(opt)
              }
            } else {
              // 数组字符串 [1,2,3]
              const opt = document.createElement('textarea')
              opt.name = `${x}[${index}]`
              opt.value = element
              form.appendChild(opt)
            }
          })
        } else if (param[x].constructor === Object) {
          for (const key in param[x]) {
            // json数组 {key: [1,2,3]}
            if (param[x][key].constructor === Array) {
              param[x][key].forEach((element, index) => {
                const opt = document.createElement('textarea')
                opt.name = `${x}[${key}][${index}]`
                opt.value = element
                form.appendChild(opt)
              })
            } else {
              // json字符串或者数字 {key: 1, key: '1'}
              const opt = document.createElement('textarea')
              opt.name = `${x}[${key}]`
              opt.value = param[x][key]
              form.appendChild(opt)
            }
          }
        } else {
          const opt = document.createElement('textarea')
          opt.name = x
          opt.value = param[x]
          form.appendChild(opt)
        }
      }
      document.body.appendChild(form)
      form.submit()
      form.remove()
    }
  }
}
export default mixin
